import React from 'react';

import { useSchool } from 'features/school';

import B3Footer from './b3Footer';
import MainFooter from './mainFooter';

const Footer = () => {
  const { schoolAlias } = useSchool();

  switch (schoolAlias) {
    case 'b3':
      return <B3Footer />;

    default:
      return <MainFooter />;
  }
};

export default Footer;
